import styled from "styled-components";

export const StyledModalSelectRadio = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 28px;

  & .radio-item {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
  }
`;
